export default {
  title: 'Mit Pix bezahlen',
  hint: 'Kopiere den Code und füge ihn in deiner Banking-App bei Pix ein oder scanne dort den QR-Code.',
  copy: 'Pix-Code kopieren',
  copied: 'Code kopiert',
  qr_alt: 'Pix-QR-Code',
  expires_in: 'Der Code läuft in {{time}} ab',
  waiting: 'Wir bestätigen deine Bestellung, sobald deine Bank die Zahlung sendet.',
  open_page: 'Stattdessen die Zahlungsseite öffnen',
  expired: 'Dieser Pix-Code ist abgelaufen. Starte die Zahlung erneut, um einen neuen zu erhalten.',
  cancel: 'Zahlung abbrechen',
  checking: 'Wir prüfen deine Zahlung…',
  close: 'Schließen',
};
